import {createContext} from 'react';

export default createContext({
  prompts: [],
  prompt: () => {},
  cancelPrompt: () => {},
  setPrompts: (stateOrFn) => {},
});
